export default __webpack_public_path__ + "static/media/Notepad++.66620d90.png";